import { createStyles, Fab, Grid, List, makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';
import { IBar } from '../../models/IBars';
import EntryItem from '../EntryItem/EntryItem.component';
import SearchBar from '../SearchBar/SearchBar.component';

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            flex: 1,
            padding: theme.spacing(0.5),
        },
        searchBar: {
            marginBottom: theme.spacing(3),
            [theme.breakpoints.down('sm')]: {
                marginBottom: 0,
            },
            [theme.breakpoints.up('md')]: {
                marginBottom: theme.spacing(1),
            },
        },
        input: {
            backgroundColor: '#fff',
        }
    }),
);

interface Props {
    data: IBar[]
    searchValue: string,
    setSearchValue: (s: string) => void,
    onCreateClick: () => void
    onDetailsClick: (entry: IBar) => void
    onDeleteClick: (entry: IBar) => void
}

export default function BarsList({
    data,
    searchValue,
    setSearchValue,
    onCreateClick,
    onDetailsClick,
    onDeleteClick
}: Props) {
    const classes = useStyles();

    return (
        <Grid container spacing={3} className={classes.root}>
            <Grid direction="row" justify="center" alignItems="center" container spacing={2} className={classes.searchBar}>
                <Grid xs item>
                    <SearchBar 
                        placeholder="Search Bars..."
                        value={searchValue}
                        setValue={setSearchValue}
                    />
                </Grid>
                <Grid item>
                    <Fab size="medium" color="primary" aria-label="add" onClick={onCreateClick}>
                        <AddIcon />
                    </Fab>
                </Grid>
            </Grid>
            <List style={{ flex: 1 }}>
                {data.map((item, index) =>
                    <EntryItem
                        entry={item}
                        onDetailsClick={onDetailsClick}
                        onDeleteClick={onDeleteClick}
                        key={index}
                    />
                )}
            </List>
        </Grid>
    );
}
